module.exports = __webpack_public_path__ + "static/media/m27.97bbce01.jpg";